export default __webpack_public_path__ + "static/media/logo-qr-code.e4e15496.svg";